import { computed, unref, type MaybeRef } from 'vue'
import { getFullscreenChatHref } from '#entities/chat'
import type { Alert } from '../model/alert'

export function useAlertLink(alert: MaybeRef<Alert>) {
  const alertLink = computed(() => {
    const alertVal = unref(alert)
    const chatId = alertVal.message.chatId
    const messageId = alertVal.type === 'reply' ? alertVal.reply.id : alertVal.message.id
    return getFullscreenChatHref(chatId, messageId)
  })

  return alertLink
}
